import React from 'react';
import SocialLink from '../SocilaLink/SocialLink';
import Banner from '../Banner/Banner';
import Contact from '../../Contact/Contact';
import MyServices from '../Services/MyServices';
import Skils from '../Skils/Skils';
import Works from '../Works/Works';

const Home = () => {
    return (
        <div>
            <Banner/>
           <SocialLink/>
           <MyServices/>
           <Works/>
           <Skils />
           <Contact/>
        </div>
    );
};

export default Home;